import { create } from 'zustand'

interface ReloginDialogState {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useReloginDialogStore = create<ReloginDialogState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
